var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('download-excel',{attrs:{"data":_vm.json_data}},[_vm._v("\n    Download Data\n    "),_c('img',{attrs:{"src":"download_icon.png"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }